module.exports = "/static/assets/ac973b51892f4a335817a8509bc79a0a.gif";